import { DndContext } from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import {
  useReorderSmartLists,
  useSortedSmartLists,
} from 'features/smart-lists';
import { OverlayComponentWrapper } from 'shared/components/ui/overlay-component-wrapper';
import { SmartListSideMenuItem } from 'shared/components/ui/smart-list-side-menu-item';
import { SortableOverlay } from 'shared/components/ui/sortable-overlay';
import { useSortableItemsControls } from 'shared/hooks/use-sortable-items-controls';
import { useSortableSensors } from 'shared/hooks/use-sortable-sensors';

import { SmartListCount } from './smart-list-count';
import { SmartListSideNavigationItem } from './smart-list-side-navigation-item';

export const SmartListsList: React.FC = () => {
  const smartLists = useSortedSmartLists();
  const onReorder = useReorderSmartLists();
  const sensors = useSortableSensors();

  const {
    items,
    activeItem,
    handleDragStart,
    handleDragCancel,
    handleDragEnd,
  } = useSortableItemsControls({
    items: smartLists,
    onDragEnd: onReorder,
  });

  return (
    <DndContext
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={handleDragCancel}
      sensors={sensors}
      measuring={{
        draggable: {
          measure: (node) => node.getBoundingClientRect(),
        },
      }}
    >
      <SortableContext
        items={items.map(({ id }) => id)}
        strategy={verticalListSortingStrategy}
      >
        {items.map((smartList) => (
          <SmartListSideNavigationItem
            key={smartList.id}
            smartList={smartList}
            hasDnd
          >
            <SmartListCount smartList={smartList} />
          </SmartListSideNavigationItem>
        ))}

        <SortableOverlay>
          {!!activeItem && (
            <OverlayComponentWrapper>
              <SmartListSideMenuItem smartList={activeItem} />
            </OverlayComponentWrapper>
          )}
        </SortableOverlay>
      </SortableContext>
    </DndContext>
  );
};
